<div class="lum-page lum-page__card lum-c-channel">
  <header class="lum-page-header lum-page-header--sticky">
    <h2 class="lum-page-header__heading">Channels</h2>
    <div class="lum-page-header__actions">
      <a class="lum-button lum-button--primary" routerLink="/channels/v2/create">
        <i class="fas fa-plus"></i>
        Create
      </a>
    </div>
  </header>
  <div class="lum-page-content">
    <div class="lum-c-channel__filters">
      <lum-channel-filters></lum-channel-filters>
      <div class="lum-c-channel__filters-actions">
        <button class="lum-button lum-button--secondary" [matMenuTriggerFor]="menu">
          Columns
        </button>
        <mat-menu #menu="matMenu">
          <ng-container *ngFor="let column of this.columns; trackBy: trackById">
            <button mat-menu-item (click)="$event.stopPropagation()">
              <mat-checkbox [(ngModel)]="column.visible">{{
                column.label
              }}</mat-checkbox>
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </div>
    <div class="mt-5 overflow-auto">
      <lum-channel-table [columns]="columns"></lum-channel-table>
    </div>
  </div>
</div>
